'use client';

import React, { cloneElement, JSXElementConstructor, ReactElement } from 'react';

import { useSlider } from '@/helpers/hooks';

interface ChaningLettersProps {
  children: ReactElement<any, string | JSXElementConstructor<any>>[];
  delay?: number;
  className?: string;
}

export default function ChaningLetters(props: ChaningLettersProps) {
  const { children, delay, className } = props;
  const maxLength = children.length - 1;
  const [activeIndex] = useSlider({ maxLength, delay });
  return (
    <>
      {React.Children.map(children, (child, index) =>
        index === activeIndex
          ? cloneElement(child, {
              ...child.props,
              className: (child.props.className || '') + ` ${className} animate-in fade-in duration-1000`,
            })
          : null
      )}
    </>
  );
}
